<template>
  <div class="radio__row">
    <div class="radio" v-for="(option,i) in options" :key="`radio-option-${i}`">
      <input :id="`radio-option-${i}`"
             type="radio"
             :name="name"
             :value="option.value"
             :checked="option.value === value"
             :disabled="option.disabled"
             @change="$emit('change', option.value)"
             hidden>
      <label :for="`radio-option-${i}`"
             class="radio__label"
             :class="[option.color || '', option.classes].join(' ')"
             v-tooltip="option.tooltip">
        {{ option.text }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    event: "change",
  },
  name: "RadioTags",
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    options: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.radio {
  &__row {
    @apply flex;
  }

  &__label {
    @apply font-normal text-md tracking-tight text-text
    mx-2 px-3-5 py-1-5
    rounded border border-border
    cursor-pointer
    transition duration-200;

    &.ml-8{
      @apply ml-8;
    }

    &:hover {
      @apply text-white bg-gray border-gray;
      &.red {
        @apply bg-red border-red;
      }

      &.green {
        @apply bg-green border-green;
      }

      &.yellow {
        @apply bg-yellow border-yellow;
      }
    }

  }

  input:checked + .radio__label {
    @apply text-white bg-gray border-gray;
    &.red {
      @apply bg-red border-red;
    }

    &.green {
      @apply bg-green border-green;
    }

    &.yellow {
      @apply bg-yellow border-yellow;
    }
  }

  input[disabled] + .radio__label {
    @apply bg-icon border-icon text-white opacity-50;
    &:hover {
      @apply bg-icon text-white border-icon;
    }
  }
}
</style>